import React from 'react';

export type IconProps = React.SVGProps<SVGSVGElement> & {
  size?: number | string;
  color?: string;
};

export const SunIcon: React.FC<IconProps> = ({ size = 20, color = '#FF9500', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <circle cx="12" cy="12" r="4.5" fill={color} />
    <g stroke={color} strokeWidth="2" strokeLinecap="round">
      <line x1="12" y1="2" x2="12" y2="4.5" />
      <line x1="12" y1="19.5" x2="12" y2="22" />
      <line x1="2" y1="12" x2="4.5" y2="12" />
      <line x1="19.5" y1="12" x2="22" y2="12" />
      <line x1="4.93" y1="4.93" x2="6.7" y2="6.7" />
      <line x1="17.3" y1="17.3" x2="19.07" y2="19.07" />
      <line x1="4.93" y1="19.07" x2="6.7" y2="17.3" />
      <line x1="17.3" y1="6.7" x2="19.07" y2="4.93" />
    </g>
  </svg>
);

export const MoonIcon: React.FC<IconProps> = ({ size = 20, color = '#5E5CE6', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <path
      d="M14.5 3C10.5 4.8 8 8.8 8 13.2C8 18.6 12.4 23 17.8 23C19 23 20.2 22.8 21.3 22.3C19.7 23.4 17.7 24 15.6 24C9.7 24 5 19.3 5 13.4C5 8 8.9 3.6 14.1 2.8C14.2 2.9 14.4 2.9 14.5 3Z"
      fill={color}
      transform="translate(0, -1)"
    />
  </svg>
);

export const PartlyCloudyDayIcon: React.FC<IconProps> = ({ size = 20, color = '#8E8E93', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <circle cx="8" cy="8" r="3" fill="#FF9500" />
    <g stroke="#FF9500" strokeWidth="1.6" strokeLinecap="round">
      <line x1="8" y1="2" x2="8" y2="3.5" />
      <line x1="2" y1="8" x2="3.5" y2="8" />
      <line x1="3.76" y1="3.76" x2="4.82" y2="4.82" />
      <line x1="12.24" y1="3.76" x2="11.18" y2="4.82" />
    </g>
    <path
      d="M7 19.5C5.07 19.5 3.5 17.93 3.5 16C3.5 14.22 4.83 12.76 6.57 12.53C7.03 10.22 9.06 8.5 11.5 8.5C14.19 8.5 16.4 10.53 16.5 13.2C18.47 13.42 20 15.08 20 17.1C20 19.25 18.25 21 16.1 21L7 21C6.2 21 5.5 20.4 5.5 19.5Z"
      fill={color}
      opacity="0.25"
    />
    <path
      d="M8.5 20C6.57 20 5 18.43 5 16.5C5 14.75 6.3 13.3 8 13.04C8.45 10.74 10.47 9 12.9 9C15.65 9 17.9 11.1 18 13.84C19.7 14.07 21 15.52 21 17.3C21 19.34 19.34 21 17.3 21L8.5 21"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const PartlyCloudyNightIcon: React.FC<IconProps> = ({ size = 20, color = '#8E8E93', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <path
      d="M11 3.5C8.8 4.7 7.5 7 7.5 9.5C7.5 11.5 8.3 13.3 9.7 14.6C8.8 14.8 7.9 15.3 7.2 16C5.5 16.3 4.2 17.7 4 19.5"
      stroke="#5E5CE6"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M8 20.5C6.07 20.5 4.5 18.93 4.5 17C4.5 15.25 5.8 13.8 7.5 13.54C7.95 11.24 9.97 9.5 12.4 9.5C15.15 9.5 17.4 11.6 17.5 14.34C19.2 14.57 20.5 16.02 20.5 17.8C20.5 19.84 18.84 21.5 16.8 21.5L8 21.5"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloudyIcon: React.FC<IconProps> = ({ size = 20, color = '#8E8E93', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <path
      d="M6.5 19.5C4.57 19.5 3 17.93 3 16C3 14.2 4.34 12.72 6.1 12.53C6.55 9.98 8.76 8 11.5 8C14.47 8 16.9 10.3 17 13.25C19.25 13.48 21 15.28 21 17.5C21 19.71 19.21 21.5 17 21.5L6.5 21.5"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const RainIcon: React.FC<IconProps> = ({ size = 20, color = '#8E8E93', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <path
      d="M6 16C4.34 16 3 14.66 3 13C3 11.45 4.15 10.18 5.65 10.03C6.04 7.74 8.02 6 10.5 6C13.16 6 15.34 8.04 15.48 10.68C17.47 10.88 19 12.47 19 14.5C19 16.43 17.43 18 15.5 18L6 18"
      stroke={color}
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <g stroke="#007AFF" strokeWidth="2" strokeLinecap="round">
      <line x1="7" y1="20" x2="5.5" y2="23" />
      <line x1="11" y1="20" x2="9.5" y2="23" />
      <line x1="15" y1="20" x2="13.5" y2="23" />
    </g>
  </svg>
);

export const HeavyRainIcon: React.FC<IconProps> = ({ size = 20, color = '#8E8E93', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <path
      d="M6 14C4.34 14 3 12.66 3 11C3 9.45 4.15 8.18 5.65 8.03C6.04 5.74 8.02 4 10.5 4C13.16 4 15.34 6.04 15.48 8.68C17.47 8.88 19 10.47 19 12.5C19 14.43 17.43 16 15.5 16L6 16"
      stroke={color}
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <g stroke="#0A84FF" strokeWidth="2.2" strokeLinecap="round">
      <line x1="6" y1="18" x2="4.5" y2="21.5" />
      <line x1="9.5" y1="18" x2="8" y2="21.5" />
      <line x1="13" y1="18" x2="11.5" y2="21.5" />
      <line x1="16.5" y1="18" x2="15" y2="21.5" />
    </g>
  </svg>
);

export const ThunderstormIcon: React.FC<IconProps> = ({ size = 20, color = '#8E8E93', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <path
      d="M6 15C4.34 15 3 13.66 3 12C3 10.45 4.15 9.18 5.65 9.03C6.04 6.74 8.02 5 10.5 5C13.16 5 15.34 7.04 15.48 9.68C17.47 9.88 19 11.47 19 13.5C19 15.43 17.43 17 15.5 17L6 17"
      stroke={color}
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <polygon
      points="11.5,14 8.5,18.5 11,18.5 9.5,23 15,17.5 12,17.5 13.5,14"
      fill="#FFD60A"
      stroke="#FFD60A"
      strokeWidth="0.5"
      strokeLinejoin="round"
    />
    <line x1="5.5" y1="19" x2="4.5" y2="21.5" stroke="#007AFF" strokeWidth="1.8" strokeLinecap="round" />
    <line x1="17.5" y1="19" x2="16.5" y2="21.5" stroke="#007AFF" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const SnowIcon: React.FC<IconProps> = ({ size = 20, color = '#8E8E93', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <path
      d="M6 15C4.34 15 3 13.66 3 12C3 10.45 4.15 9.18 5.65 9.03C6.04 6.74 8.02 5 10.5 5C13.16 5 15.34 7.04 15.48 9.68C17.47 9.88 19 11.47 19 13.5C19 15.43 17.43 17 15.5 17L6 17"
      stroke={color}
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <g fill="#64D2FF">
      <circle cx="7" cy="20" r="1.3" />
      <circle cx="11.5" cy="21" r="1.3" />
      <circle cx="16" cy="20" r="1.3" />
      <circle cx="9" cy="18" r="1" />
      <circle cx="14" cy="18" r="1" />
    </g>
  </svg>
);

export const FogIcon: React.FC<IconProps> = ({ size = 20, color = '#8E8E93', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <g stroke={color} strokeWidth="2" strokeLinecap="round">
      <line x1="4" y1="7" x2="20" y2="7" />
      <line x1="6" y1="11" x2="18" y2="11" />
      <line x1="3" y1="15" x2="21" y2="15" />
      <line x1="7" y1="19" x2="17" y2="19" />
    </g>
  </svg>
);

export const WindIcon: React.FC<IconProps> = ({ size = 20, color = '#30B0C7', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <path d="M3 8.5H16.5C18 8.5 19.5 7.5 19.5 5.5C19.5 3.5 17.8 2 16 2C14.2 2 13 3.5 13 5" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M2 12.5H19C20.5 12.5 22 13.8 22 15.5C22 17.5 20.2 19 18.5 19C16.8 19 15.5 17.5 15.5 16" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M4 16.5H12C13.2 16.5 14.5 17.5 14.5 19C14.5 20.5 13.2 21.5 12 21.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const CarNavIcon: React.FC<IconProps> = ({ size = 20, color = '#007AFF', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <circle cx="12" cy="12" r="10.5" fill={color} fillOpacity="0.15" />
    <path d="M12 4L18.5 18.5L12 15.5L5.5 18.5L12 4Z" fill={color} stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

export const ClockEtaIcon: React.FC<IconProps> = ({ size = 20, color = '#8E8E93', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" />
    <polyline points="12,7 12,12 15.5,14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const HazardAlertIcon: React.FC<IconProps> = ({ size = 20, color = '#FF9500', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="none" {...props}>
    <path
      d="M12 3.2L21.3 19.5C21.7 20.2 21.2 21 20.4 21H3.6C2.8 21 2.3 20.2 2.7 19.5L12 3.2Z"
      fill={color}
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <line x1="12" y1="9.5" x2="12" y2="14" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="17.5" r="1" fill="#FFFFFF" />
  </svg>
);

/**
 * Universal Weather Icon resolver matching Open-Meteo categories and day/night state.
 */
export function WeatherIcon({
  category,
  isDay = true,
  size = 20,
  ...props
}: {
  category: 'sun' | 'cloud' | 'rain' | 'snow' | 'thunder' | 'fog';
  isDay?: boolean;
  size?: number | string;
} & React.SVGProps<SVGSVGElement>) {
  switch (category) {
    case 'sun':
      return isDay ? <SunIcon size={size} {...props} /> : <MoonIcon size={size} {...props} />;
    case 'cloud':
      return isDay ? <PartlyCloudyDayIcon size={size} {...props} /> : <PartlyCloudyNightIcon size={size} {...props} />;
    case 'rain':
      return <RainIcon size={size} {...props} />;
    case 'thunder':
      return <ThunderstormIcon size={size} {...props} />;
    case 'snow':
      return <SnowIcon size={size} {...props} />;
    case 'fog':
      return <FogIcon size={size} {...props} />;
    default:
      return <CloudyIcon size={size} {...props} />;
  }
}

/**
 * Pure SVG markup strings for DOM marker injection (MapView.tsx).
 */
export function getWeatherSvgString(
  category: 'sun' | 'cloud' | 'rain' | 'snow' | 'thunder' | 'fog',
  isDay = true,
  size = 14,
): string {
  switch (category) {
    case 'sun':
      return isDay
        ? `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><circle cx="12" cy="12" r="4.5" fill="#FF9500"/><g stroke="#FF9500" stroke-width="2" stroke-linecap="round"><line x1="12" y1="2" x2="12" y2="4.5"/><line x1="12" y1="19.5" x2="12" y2="22"/><line x1="2" y1="12" x2="4.5" y2="12"/><line x1="19.5" y1="12" x2="22" y2="12"/><line x1="4.93" y1="4.93" x2="6.7" y2="6.7"/><line x1="17.3" y1="17.3" x2="19.07" y2="19.07"/><line x1="4.93" y1="19.07" x2="6.7" y2="17.3"/><line x1="17.3" y1="6.7" x2="19.07" y2="4.93"/></g></svg>`
        : `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><path d="M14.5 3C10.5 4.8 8 8.8 8 13.2C8 18.6 12.4 23 17.8 23C19 23 20.2 22.8 21.3 22.3C19.7 23.4 17.7 24 15.6 24C9.7 24 5 19.3 5 13.4C5 8 8.9 3.6 14.1 2.8C14.2 2.9 14.4 2.9 14.5 3Z" fill="#5E5CE6" transform="translate(0, -1)"/></svg>`;
    case 'cloud':
      return isDay
        ? `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><circle cx="8" cy="8" r="3" fill="#FF9500"/><g stroke="#FF9500" stroke-width="1.6" stroke-linecap="round"><line x1="8" y1="2" x2="8" y2="3.5"/><line x1="2" y1="8" x2="3.5" y2="8"/><line x1="3.76" y1="3.76" x2="4.82" y2="4.82"/><line x1="12.24" y1="3.76" x2="11.18" y2="4.82"/></g><path d="M8.5 20C6.57 20 5 18.43 5 16.5C5 14.75 6.3 13.3 8 13.04C8.45 10.74 10.47 9 12.9 9C15.65 9 17.9 11.1 18 13.84C19.7 14.07 21 15.52 21 17.3C21 19.34 19.34 21 17.3 21L8.5 21" stroke="#8E8E93" stroke-width="2" stroke-linejoin="round"/></svg>`
        : `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><path d="M11 3.5C8.8 4.7 7.5 7 7.5 9.5C7.5 11.5 8.3 13.3 9.7 14.6C8.8 14.8 7.9 15.3 7.2 16C5.5 16.3 4.2 17.7 4 19.5" stroke="#5E5CE6" stroke-width="2" stroke-linecap="round"/><path d="M8 20.5C6.07 20.5 4.5 18.93 4.5 17C4.5 15.25 5.8 13.8 7.5 13.54C7.95 11.24 9.97 9.5 12.4 9.5C15.15 9.5 17.4 11.6 17.5 14.34C19.2 14.57 20.5 16.02 20.5 17.8C20.5 19.84 18.84 21.5 16.8 21.5L8 21.5" stroke="#8E8E93" stroke-width="2" stroke-linejoin="round"/></svg>`;
    case 'rain':
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><path d="M6 16C4.34 16 3 14.66 3 13C3 11.45 4.15 10.18 5.65 10.03C6.04 7.74 8.02 6 10.5 6C13.16 6 15.34 8.04 15.48 10.68C17.47 10.88 19 12.47 19 14.5C19 16.43 17.43 18 15.5 18L6 18" stroke="#8E8E93" stroke-width="1.8" stroke-linejoin="round"/><g stroke="#007AFF" stroke-width="2" stroke-linecap="round"><line x1="7" y1="20" x2="5.5" y2="23"/><line x1="11" y1="20" x2="9.5" y2="23"/><line x1="15" y1="20" x2="13.5" y2="23"/></g></svg>`;
    case 'thunder':
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><path d="M6 15C4.34 15 3 13.66 3 12C3 10.45 4.15 9.18 5.65 9.03C6.04 6.74 8.02 5 10.5 5C13.16 5 15.34 7.04 15.48 9.68C17.47 9.88 19 11.47 19 13.5C19 15.43 17.43 17 15.5 17L6 17" stroke="#8E8E93" stroke-width="1.8" stroke-linejoin="round"/><polygon points="11.5,14 8.5,18.5 11,18.5 9.5,23 15,17.5 12,17.5 13.5,14" fill="#FFD60A" stroke="#FFD60A" stroke-width="0.5" stroke-linejoin="round"/><line x1="5.5" y1="19" x2="4.5" y2="21.5" stroke="#007AFF" stroke-width="1.8" stroke-linecap="round"/><line x1="17.5" y1="19" x2="16.5" y2="21.5" stroke="#007AFF" stroke-width="1.8" stroke-linecap="round"/></svg>`;
    case 'snow':
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><path d="M6 15C4.34 15 3 13.66 3 12C3 10.45 4.15 9.18 5.65 9.03C6.04 6.74 8.02 5 10.5 5C13.16 5 15.34 7.04 15.48 9.68C17.47 9.88 19 11.47 19 13.5C19 15.43 17.43 17 15.5 17L6 17" stroke="#8E8E93" stroke-width="1.8" stroke-linejoin="round"/><g fill="#64D2FF"><circle cx="7" cy="20" r="1.3"/><circle cx="11.5" cy="21" r="1.3"/><circle cx="16" cy="20" r="1.3"/><circle cx="9" cy="18" r="1"/><circle cx="14" cy="18" r="1"/></g></svg>`;
    case 'fog':
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><g stroke="#8E8E93" stroke-width="2" stroke-linecap="round"><line x1="4" y1="7" x2="20" y2="7"/><line x1="6" y1="11" x2="18" y2="11"/><line x1="3" y1="15" x2="21" y2="15"/><line x1="7" y1="19" x2="17" y2="19"/></g></svg>`;
    default:
      return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><path d="M6.5 19.5C4.57 19.5 3 17.93 3 16C3 14.2 4.34 12.72 6.1 12.53C6.55 9.98 8.76 8 11.5 8C14.47 8 16.9 10.3 17 13.25C19.25 13.48 21 15.28 21 17.5C21 19.71 19.21 21.5 17 21.5L6.5 21.5" stroke="#8E8E93" stroke-width="2" stroke-linejoin="round"/></svg>`;
  }
}

export function getCarSvgString(size = 14, color = '#FFFFFF'): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><circle cx="12" cy="12" r="10.5" fill="${color}" fill-opacity="0.2"/><path d="M12 4L18.5 18.5L12 15.5L5.5 18.5L12 4Z" fill="${color}" stroke="${color}" stroke-width="1.5" stroke-linejoin="round"/></svg>`;
}

export function getDropSvgString(size = 10, color = '#007AFF'): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><path d="M12 2.5C12 2.5 6 9.5 6 14.5C6 17.8 8.7 20.5 12 20.5C15.3 20.5 18 17.8 18 14.5C18 9.5 12 2.5 12 2.5Z" fill="${color}"/></svg>`;
}

export function getWindSvgString(size = 14, color = '#30B0C7'): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><path d="M3 8.5H16.5C18 8.5 19.5 7.5 19.5 5.5C19.5 3.5 17.8 2 16 2C14.2 2 13 3.5 13 5" stroke="${color}" stroke-width="2" stroke-linecap="round"/><path d="M2 12.5H19C20.5 12.5 22 13.8 22 15.5C22 17.5 20.2 19 18.5 19C16.8 19 15.5 17.5 15.5 16" stroke="${color}" stroke-width="2" stroke-linecap="round"/><path d="M4 16.5H12C13.2 16.5 14.5 17.5 14.5 19C14.5 20.5 13.2 21.5 12 21.5" stroke="${color}" stroke-width="2" stroke-linecap="round"/></svg>`;
}

export function getSunSvgString(size = 14, color = '#FF9500'): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><circle cx="12" cy="12" r="4.5" fill="${color}"/><g stroke="${color}" stroke-width="2" stroke-linecap="round"><line x1="12" y1="2" x2="12" y2="4.5"/><line x1="12" y1="19.5" x2="12" y2="22"/><line x1="2" y1="12" x2="4.5" y2="12"/><line x1="19.5" y1="12" x2="22" y2="12"/><line x1="4.93" y1="4.93" x2="6.7" y2="6.7"/><line x1="17.3" y1="17.3" x2="19.07" y2="19.07"/><line x1="4.93" y1="19.07" x2="6.7" y2="17.3"/><line x1="17.3" y1="6.7" x2="19.07" y2="4.93"/></g></svg>`;
}

export function getClockSvgString(size = 12, color = '#8E8E93'): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none"><circle cx="12" cy="12" r="9" stroke="${color}" stroke-width="2"/><polyline points="12,7 12,12 15.5,14" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
}
